/* eslint-disable */
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Canvas } from '@react-three/fiber';
import { motion } from 'framer-motion';
import Scene from '../../../../src/components/auth/Scene';
import ChatBubble from '../../../../src/components/auth/ChatBubble';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../../api/axiosClient';
import '../../../assets/css/SignIn.css';
import { useAuth } from '../../../contexts/AuthContext';

export default function SignIn() {
  const { login, getRedirectByRole } = useAuth();

  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const mouse = useRef({ x: 0, y: 0 });
  const triggerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const onMove = (e) => {
      mouse.current.x = (e.clientX / window.innerWidth - 0.5) * 2;
      mouse.current.y = (e.clientY / window.innerHeight - 0.5) * 2;
    };

    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  const handleCardHover = useCallback(() => {
    triggerRef.current?.wave?.();
  }, []);

  const handlePasswordFocus = useCallback(() => {
    triggerRef.current?.turnBackThenWave?.();
  }, []);

  const handleEmailFocus = useCallback(() => {
    triggerRef.current?.nod?.();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setLoading(true);

    triggerRef.current?.loading?.();

    try {
      const response = await axiosClient.post(`/auth/login`, {
        email,
        password,
      });

      const token = response.data?.token;
      const role = response.data?.user?.role;
      const id_pegawai = response.data?.user?.id;
      const telegram_chat_id = response.data?.user?.telegram_chat_id;

      if (token) {
        triggerRef.current?.success?.();

        login({ token, role, id_pegawai, telegram_chat_id });

        setTimeout(() => {
          navigate(getRedirectByRole(role), { replace: true });
        }, 450);
      } else {
        throw new Error('Token tidak ditemukan di respon server');
      }
    } catch (error) {
      console.error(error);
      triggerRef.current?.shake?.();

      const message =
        error.response?.data?.message ||
        'Login gagal. Periksa kembali email dan password.';

      setErrorMsg(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-3d-root">
      <div className="auth-bg-orb orb-1"></div>
      <div className="auth-bg-orb orb-2"></div>
      <div className="auth-bg-orb orb-3"></div>

      <motion.div
        className="auth-shell"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <motion.div
          className="canvas-wrap"
          aria-hidden
          initial={{ opacity: 0, x: -180, scale: 0.85 }}
          animate={{ opacity: 1, x: 0, scale: 1 }}
          transition={{
            duration: 1.1,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          <div className="robot-glow"></div>

          <Canvas camera={{ position: [0, 0.8, 3.2], fov: 35 }}>
            <Scene mouse={mouse} triggerRef={triggerRef} />
          </Canvas>

          <ChatBubble
            text="Halo! Aku siap bantu kamu masuk ke ResolveIT 🚀"
            onDisappear={() => triggerRef.current?.wave?.()}
          />
        </motion.div>

        <motion.div
          className="signin-card"
          onMouseEnter={handleCardHover}
          initial={{ opacity: 0, y: 50, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ delay: 0.35, duration: 0.7 }}
        >
          <h1 className="title">Login</h1>
          <p className="subtitle">Sign in to continue</p>

          <form className="form" onSubmit={handleLogin}>
            <label>
              Email <span className="req">*</span>
            </label>

            <input
              type="email"
              placeholder="mail@domain.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onFocus={handleEmailFocus}
              required
            />

            <label>
              Password <span className="req">*</span>
            </label>

            <div className="password-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Min. 8 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={handlePasswordFocus}
                required
              />

              <button
                type="button"
                className="eye"
                onClick={() => setShowPassword((s) => !s)}
                aria-label="toggle-password"
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>

            {errorMsg && <p className="error-msg">{errorMsg}</p>}

            <button className="submit" disabled={loading}>
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>

          <p className="foot">
            Not registered? <a href="/auth/sign-up">Create an Account</a>
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
}